import { __zcAsy, __zcFin, __zcIT, __zcITc, __zcMkv, __zcRd, __zcRf } from "__zod-compiler-runtime__";
import * as z from 'zod'

import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {LinkSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/link'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'

const COMPONENT_ID = 'pricingTableColumn'

export const PricingTableColumnSchema = /* @__PURE__ */ (() => {
var __zs=buildEntrySchemaFor(COMPONENT_ID, {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      price: z.number().optional(),
      currency: z.string().optional(),
      ctaPrimary: safeOptional(LinkSchema),
      ctaSecondary: safeOptional(LinkSchema),
    }),
  ),
});
var __rf=[__zs._zod.innerType.shape["sys"].shape["contentType"],__zs._zod.innerType.shape["fields"]._zod.innerType.shape["ctaPrimary"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["ctaSecondary"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __rfz_0=__rf[0]._zod;
var __rfn_16=__rf[1];
var __rfn_19=__rf[2];
function safeParse_PricingTableColumnSchema(input){
var _e=[];
var _d=input;
if(typeof _d!=="object"||_d===null||Array.isArray(_d)){_e.push(__zcIT("object",_d,[]));}else{var __sv_1=_d["sys"];if(typeof __sv_1!=="object"||__sv_1===null||Array.isArray(__sv_1)){_e.push(__zcIT("object",__sv_1,["sys"]));}else{var __sv_3=__sv_1["id"];if(typeof __sv_3!=="string"){_e.push(__zcIT("string",__sv_3,["sys","id"]));}
var __sv_4=__sv_1["updatedAt"];if(__sv_4!==undefined){if(typeof __sv_4!=="string"){_e.push(__zcIT("string",__sv_4,["sys","updatedAt"]));}
}
var __sv_5=__sv_1["createdAt"];if(__sv_5!==undefined){if(typeof __sv_5!=="string"){_e.push(__zcIT("string",__sv_5,["sys","createdAt"]));}
}
var __sv_6=__sv_1["contentType"];var __op_8="contentType" in __sv_1;var __ob_7=_e.length;var __rf_c0={async:false};var __rf_r0=__zcRd(__rfz_0,__sv_6,__rf_c0);if(__rf_r0.issues.length){__zcRf(__rf_r0.issues,__rf_c0,_e,["sys","contentType"]);}else{__sv_6=__rf_r0.value;}
if(!__op_8){__sv_6=undefined;if(_e.length===__ob_7){_e.push(__zcITc("nonoptional",undefined,["sys","contentType"]));}}var __o_2={"id":__sv_3};if(__sv_4!==undefined||("updatedAt" in __sv_1)){__o_2["updatedAt"]=__sv_4;}if(__sv_5!==undefined||("createdAt" in __sv_1)){__o_2["createdAt"]=__sv_5;}if(__sv_6!==undefined||("contentType" in __sv_1)){__o_2["contentType"]=__sv_6;}__sv_1=__o_2;}
var __sv_9=_d["fields"];if(typeof __sv_9!=="object"||__sv_9===null||Array.isArray(__sv_9)){_e.push(__zcIT("object",__sv_9,["fields"]));}else{var __sv_11=__sv_9["title"];if(typeof __sv_11!=="string"){_e.push(__zcIT("string",__sv_11,["fields","title"]));}
var __sv_12=__sv_9["price"];if(__sv_12!==undefined){if(typeof __sv_12!=="number"){_e.push(__zcIT("number",__sv_12,["fields","price"]));}else if(Number.isNaN(__sv_12)){_e.push({expected:"number",code:"invalid_type",received:"NaN",input:__sv_12,path:["fields","price"]});}else if(!Number.isFinite(__sv_12)){_e.push({expected:"number",code:"invalid_type",received:String(__sv_12),input:__sv_12,path:["fields","price"]});}
}
var __sv_13=__sv_9["currency"];if(__sv_13!==undefined){if(typeof __sv_13!=="string"){_e.push(__zcIT("string",__sv_13,["fields","currency"]));}
}
var __sv_14=__sv_9["ctaPrimary"];if(__sv_14!==undefined){var __ib_15=_e.length;if(_e.length===__ib_15){__sv_14=__rfn_16(__sv_14);if(__sv_14 instanceof Promise)__zcAsy();}
}
var __sv_17=__sv_9["ctaSecondary"];if(__sv_17!==undefined){var __ib_18=_e.length;if(_e.length===__ib_18){__sv_17=__rfn_19(__sv_17);if(__sv_17 instanceof Promise)__zcAsy();}
}
var __o_10={"title":__sv_11};if(__sv_12!==undefined||("price" in __sv_9)){__o_10["price"]=__sv_12;}if(__sv_13!==undefined||("currency" in __sv_9)){__o_10["currency"]=__sv_13;}if(__sv_14!==undefined||("ctaPrimary" in __sv_9)){__o_10["ctaPrimary"]=__sv_14;}if(__sv_17!==undefined||("ctaSecondary" in __sv_9)){__o_10["ctaSecondary"]=__sv_17;}__sv_9=__o_10;}
var __o_0={"sys":__sv_1,"fields":__sv_9};_d=__o_0;}

if(_e.length===0){return{success:true,data:_d};}
return __zcFin(_e,_d);
}
return __zcMkv(safeParse_PricingTableColumnSchema,__zs,null,null);
})()

export type PricingTableColumn = z.infer<typeof PricingTableColumnSchema>
